// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3HvhS","overflowing":"ReadFullNote_overflowing__2kZ8Q"};